<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'app',
    methods: {
        ...mapActions('authentication', [
            'logout',
        ]),
    },
    watch: {
        '$route': function(to)
        {
            if (to.name === 'logout')
            {
                this.logout.then(() =>
                {
                    this.$router.push({path: '/'});
                });
            }
        },
    },
};
</script>
